import { NumberInput as NI, type NumberInputEventHandler as NIEH } from '../src/NumberInput';

// working around an error with re-exporting the type:
// ("NumberInputEventHandler" not found in '../src/NumberInput')
export type NumberInputEventHandler = NIEH;
export const NumberInput = NI;
